import React from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import TodoProductItem from '@/screens/sales-activity/components/todo-list/on-going/product/TodoProductItem';
import Colors from '@global/colors';
import { ActivityIndicator } from 'react-native';
import { productKeyExtractor } from './TodoVisibilityUpdate.utils';

const OtherProductsFooter = ({
  isSearch,
  lastPayloadOther,
  listProduct,
  detailData,
  detailTodo,
  setLastPayloadOther,
  customerAddress,
  navigation,
  isHasSearchLoadMore,
  loadingMore,
  skip,
  limit,
  onSearchProducts,
  searchKeyword,
  handleProductUpdate,
  accountGroupId = null,
  isValueSellOutOnly = false,
}) => {
  if (!isSearch && !lastPayloadOther?.length) {
    return null;
  }

  const otherProducts = isSearch
    ? listProduct?.other_search ?? []
    : lastPayloadOther;
  const count = otherProducts?.length ?? 0;

  const onChangeProduct = (val) => {
    if (handleProductUpdate) {
      handleProductUpdate(val, true);
    } else {
      setLastPayloadOther(val);
    }
  };

  return (
    <View
      testID="todo-visibility-other-products-footer"
      style={styles.sectionContainer}>
      <View style={styles.sectionHeader}>
        <SociollaText type="medium" style={styles.sectionTitle}>
          Other Products
        </SociollaText>
        <View style={styles.countBadge}>
          <SociollaText type="medium" style={styles.countText}>
            {count}
          </SociollaText>
        </View>
      </View>

      {count ? (
        <View style={styles.listWrapper}>
          {otherProducts.map((pr, productIndex) => (
            <View
              key={productKeyExtractor(pr, productIndex)}
              style={[
                styles.productItemWrapper,
                productIndex === 0 ? styles.productItemFirst : null,
              ]}>
              <TodoProductItem
                item={pr}
                selectedProduct={lastPayloadOther}
                activityId={detailData?._id}
                todoId={detailTodo?._id}
                isOther
                onChange={onChangeProduct}
                customerAddress={customerAddress}
                taskIdStorage={detailTodo?._id ?? ''}
                isOtherProduct
                navigation={navigation}
                accountGroupId={accountGroupId}
                isValueSellOutOnly={isValueSellOutOnly}
              />
            </View>
          ))}

          {isSearch && isHasSearchLoadMore ? (
            <TouchableOpacity
              testID="todo-visibility-other-products-load-more"
              style={styles.loadMore}
              activeOpacity={0.6}
              onPress={() => {
                if (!loadingMore['search']) {
                  const newSkip = (skip['search'] ?? 0) + limit;
                  onSearchProducts({
                    keyword: searchKeyword,
                    brand_id: '',
                    product_skip: newSkip,
                  });
                }
              }}>
              <SociollaText type="medium" style={styles.loadMoreText}>
                {loadingMore['search'] ? (
                  <ActivityIndicator color={Colors.blue} />
                ) : (
                  'Load More'
                )}
              </SociollaText>
            </TouchableOpacity>
          ) : null}
        </View>
      ) : (
        <View style={styles.productEmpty}>
          <SociollaText style={styles.productEmptyText}>
            Other product not found.
          </SociollaText>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  sectionContainer: {
    marginHorizontal: 12,
    marginTop: 10,
    marginBottom: 6,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: Colors.grey10,
    backgroundColor: Colors.white,
    overflow: 'hidden',
  },
  sectionHeader: {
    paddingHorizontal: 14,
    paddingVertical: 12,
    backgroundColor: Colors.grey5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey10,
  },
  sectionTitle: {
    fontSize: 15,
    color: Colors.black1 ?? Colors.black,
  },
  countBadge: {
    minWidth: 28,
    height: 24,
    borderRadius: 12,
    backgroundColor: Colors.white,
    borderWidth: 1,
    borderColor: Colors.grey10,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 8,
  },
  countText: {
    fontSize: 12,
    color: Colors.grey60,
  },
  listWrapper: {
    backgroundColor: Colors.white,
  },
  productItemWrapper: {
    borderTopWidth: 1,
    borderTopColor: Colors.grey5,
  },
  productItemFirst: {
    borderTopWidth: 0,
  },
  loadMore: {
    margin: 12,
    borderWidth: 1,
    borderColor: Colors.grey10,
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 12,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.grey5,
  },
  loadMoreText: {
    fontSize: 13,
    color: Colors.grey60,
  },
  productEmpty: {
    paddingVertical: 18,
    paddingHorizontal: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
  productEmptyText: {
    fontSize: 14,
    color: Colors.grey60,
  },
});

export default React.memo(OtherProductsFooter);

OtherProductsFooter.propTypes = {
  isSearch: PropTypes.bool,
  lastPayloadOther: PropTypes.array,
  listProduct: PropTypes.object,
  detailData: PropTypes.object,
  detailTodo: PropTypes.object,
  setLastPayloadOther: PropTypes.func,
  customerAddress: PropTypes.object,
  navigation: PropTypes.object,
  isHasSearchLoadMore: PropTypes.bool,
  loadingMore: PropTypes.object,
  skip: PropTypes.object,
  limit: PropTypes.number,
  onSearchProducts: PropTypes.func,
  searchKeyword: PropTypes.string,
  handleProductUpdate: PropTypes.func,
  accountGroupId: PropTypes.string,
  isValueSellOutOnly: PropTypes.bool,
};
